export enum AUTH_STATUS {
  notAuth = 0,
  checking = 1,
  return = 2
}

export default function useTable() {
  const columns = [
    {
      name: 'title',
      label: 'api名称'
    },
    {
      name: 'description',
      label: 'api详情描述'
    },
    {
      name: 'path',
      label: 'api访问路径'
    },
    {
      name: 'status',
      label: '授权状态',
      width: '130px',
      render: (h: any, { row }: any) => {
        const status = row.status
        const textMap = {
          [AUTH_STATUS.notAuth]: '未申请',
          [AUTH_STATUS.checking]: '待审核',
          [AUTH_STATUS.return]: '已退回'
        }
        const typeMap = {
          [AUTH_STATUS.notAuth]: 'info',
          [AUTH_STATUS.checking]: 'warning',
          [AUTH_STATUS.return]: 'info'
        }
        const type = typeMap[status]
        const text = textMap[status]
        return (
          <span type={type} class={'status-' + type + ' status-icon'}>
            {text}
          </span>
        )
      }
    }
  ]
  const operations = [
    {
      role: 'open',
      label: '申请授权'
    }
  ]

  return {
    columns,
    operations
  }
}
